import { clientFetch } from '../clientFetch';

/*
 * get doctor insurance
 */
export const getDoctorInsurance = (personId) => {
  return clientFetch(`/search/doctors/insurance?personId=${personId}`);
};
